import React, { useEffect, useState } from 'react'

export default function EventCalendarRow(props) {

  var id = props.data.id
  var start = props.data.start
  var title = props.data.title
  var body = props.data.body

  const formatDate = function (d) {
    var date = new Date(d);
    var res = '';
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1);
    var yyyy = date.getFullYear();

    res = mm + '/' + dd + '/' + yyyy;
    return res
  }

  return (
    <>
      <div>
        <h6 className='fw-bold'><a style={{color:'black'}} className='text-black' href={"/ViewEvent/" + id}>{start == "TBD" ? "Date to be Determined" : formatDate(start)} - {title} <i className="pi pi-link"></i> </a></h6>
        <p>{body}</p>
      </div>
      <hr />
    </>
  )
}